export enum StorageKeys {
  token = 'Token',
  antiCSRFToken = 'AntiCSRFToken',
  languageUUID = 'LanguageUUID',
  initialConfig = 'InitialConfig',
  user = 'UserData',
}
